import React, { Component } from "react";
import "./ventas.css";
import "../registrosPage/ventas.css";
import "./control.css";
import { Col, Container, Row } from 'reactstrap';
import { withRouter, } from "react-router-dom";
import moment from 'moment'
import Modal from 'react-modal'
import TimeAgo from 'react-timeago'
import spanishStrings from 'react-timeago/lib/language-strings/es'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'
import Loader from "react-loader-spinner";
import Select from 'react-select'

const formatter = buildFormatter(spanishStrings)
const customStylesOption = { control: styles => ({ ...styles, backgroundColor: '#fff', width: '90%', margin: '0 auto', marginBottom: 20, }), }
const customStyles = { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '70%',height: '70%',} };


class RegistrosControlProductosPage extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      date: moment().format('YYYY-MM-DD'),
      arrayListProductos: [],
      //Listado donde se mostrarán los productos que se pueden migrar
      arrayListResults: [],
      valSearch: '',
      indexLetter: -1,
      indexProducto: -1,
      producto: '',
      arraySelecteds: [],
      isOpenUpdateProduct: false,
      id_categoria_selected: '',
    }

    this.keyBindingBtns = this.keyBindingBtns.bind(this);
  }

  componentDidMount() {
    //Petition wuuuu
    this.getCostosByDate()
    document.addEventListener("keydown", this.keyBindingBtns, false);
    this.props.onRef(this)
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keyBindingBtns, false);
  }

  keyBindingBtns(event) {
    const { indexItemByKeyboard, } = this.state
    const { renderView } = this.props.initState

    // if(renderView !== '')
    //   return false

    // [productos] F2  -> 113
    // [clientes]  F4  -> 115
    // [pagar]     F6  -> 117
    // [pagar]     F8  -> 119
    // [cancelar]  F9  -> 120
    // [ventas]    F10  -> 121
    // [nuevo]     F12 -> 123
    // [abajo]     ⬇  -> 40
    // [arriba]    ⬆  -> 38
    // [enter]     ⤵  -> 13
    // [tabulator] >  -> 9

    if(event.keyCode === 40) {

    } else if(event.keyCode === 38) {

    } else if(event.keyCode === 13) {
      
    }

  }

  __updateCosts() {
    //Firsts get all costs
    this.getCostosByDate()
  }

  render() {
    const {
      arrayListProductos,
      arrayListResults,
      valSearch,

      indexLetter,
      indexProducto,
    } = this.state

    let canUnificar = false,
    arrayPrincipal = 0;

    arrayListResults.map((t) => { if( t.active ) { canUnificar = true } })

    if(indexLetter > -1 && indexProducto > -1)
      arrayPrincipal = arrayListProductos[indexLetter].listado[indexProducto]
    

    return (
      <>
        <div className="initialPage__wrapper"  style={{ backgroundColor: 'transparent', }}>
          {/* Principal Container */}
          <Row style={{ width: '99%', margin: '0 auto' }}>
            <Col md={'6'} style={{ background: '#fff', padding: 15, }} className={'z-depth-1'}>
              {
                arrayListProductos.length === 0 ? (
                  <Row >
                    <p style={{ textAlign: 'center', width: '100%', }}>Espera un momento por favor...</p>
                  </Row>
                ) : (
                  <>
                    <div>
                      {
                        arrayListProductos.map((a,b) => (
                          <div style={{
                            margin: '4px 0',
                            padding: '5px',
                          }}>
                            <p
                              onClick={ () => { this.onExpandLetter(b) }}
                              style={{ margin: 0, cursor: 'pointer', background: '#f3f3f3', borderRadius: '4px', }}>{a.letter} ({a.listado.length})</p>

                            { a.show ? (
                                <Row>
                                  <Col xs={'2'}>
                                    <b>Código</b>
                                  </Col>
                                  <Col xs={'5'}>
                                    <b>Nombre</b>
                                  </Col>
                                  <Col xs={'2'}>
                                    <b>P. Venta</b>
                                  </Col>
                                  <Col xs={'3'}>
                                    <b>Fecha actualizado</b>
                                  </Col>
                                </Row>
                              ) : null
                            }

                            { a.show && a.listado.map((t,e) => (
                                <Row
                                  onClick={ () => {
                                    this.onSelectProductoPrincipal(e)
                                  }}
                                  key={`ws_list_compra_${e}`}
                                  style={{ width: '100%', margin: '0 auto', marginTop: 10, marginBottom: 10, }}
                                  className={`regControlProductoPage__content ${ e == indexProducto ? 'active' : '' }`}
                                  >
                                  <Col xs={'2'} className="regVentaPage__listProduct">
                                    <p style={{ color: '#333' }}>{t.folio}</p>
                                  </Col>
                                  <Col xs={'5'} className="regVentaPage__listProduct">
                                    <b style={{ color: '#333', marginTop: 8, display: 'block', }}>{t.only_nombre}</b>
                                  </Col>
                                  <Col xs={'2'} className="regVentaPage__listProduct">
                                    <p style={{ color: '#333' }}>${this.number_format(t.precio_venta,2)}</p>
                                  </Col>
                                  <Col xs={'3'} className="regVentaPage__listProduct">
                                    <TimeAgo
                                      style={{ color: (t.update == 1 ? '#333' : '#333'), }}
                                      className="__listViewPending_time" date={t.fecha_cambio_costo} formatter={formatter}
                                    />
                                  </Col>
                                </Row>
                              ))
                            }
                          </div>
                        ))
                      }
                    </div>
                  </>
                )
              }

            </Col>

            <Col md={'6'} style={{ background: '#fff', padding: 15, }} className={'z-depth-1'}>

              {
                arrayListResults.length === 0 ? (
                  <p style={{ textAlign: 'center', width: '100%', }}>Para unificar productos por favor, selecciona un producto en el menú de la izquierda</p>
                ) : (
                  <>
                    <Row>
                      <Col>
                        <b style={{ margin: 0, padding: 0, }}>SELECCIONASTE</b>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p style={{ margin: 0, padding: 0, }}>Nombre: <b>{arrayPrincipal.only_nombre.toUpperCase()}</b></p>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p style={{ margin: 0, padding: 0, }}>Código: <b>{arrayPrincipal.folio.toUpperCase()}</b></p>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p style={{ margin: 0, padding: 0, }}>Precio venta: <b>${this.number_format(arrayPrincipal.precio_venta,2)}</b></p>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={1}>
                        <p style={{ margin: 0, padding: 0, }}>Fecha:</p>
                      </Col>
                      <Col>
                        <TimeAgo
                          style={{ color: (arrayPrincipal.update == 1 ? '#333' : '#333'), }}
                          className="__listViewPending_time" date={arrayPrincipal.fecha_cambio_costo} formatter={formatter}
                        />
                      </Col>
                    </Row>
                    <Row style={{ background: '#fff', paddingBottom: 0, marginBottom: 0, }}>
                      {
                        canUnificar ? (
                          <button
                            onClick={() => { this.setUpdateUnificaProductos(1) }}
                            className={'btn btn-danger'}
                            >Unificar productos</button>
                        ) : null
                      }
                      <input
                        type="text"
                        id={'ws-input-search-code'}
                        autoComplete="off"
                        placeholder="Ingresa el nombre del producto..."
                        value={valSearch}
                        onChange={(e) => this.onSearchProducto(e.target.value) } 
                        onKeyDown={this._handleKeyDown}
                        style={{ margin: '20px auto', width: '100%', background: '#f3f3f3', border: '1px solid #ccc', borderRadius: 4, }}
                      />
                    </Row>
                    <div style={{
                      margin: '4px 0',
                      padding: '5px',
                    }}>
                      <Row>
                        <Col xs={'2'}>
                          <b>Código</b>
                        </Col>
                        <Col xs={'5'}>
                          <b>Nombre</b>
                        </Col>
                        <Col xs={'2'}>
                          <b>P. Venta</b>
                        </Col>
                        <Col xs={'3'}>
                          <b>Fecha actualizado</b>
                        </Col>
                      </Row>
                      {
                        arrayListResults.map((t,e) => (
                          <Row
                            onClick={ () => {
                              this.onSelectProductoSecundario(e)
                            }}
                            key={`ws_list_compra_${e}`}
                            style={{ width: '100%', margin: '0 auto', marginTop: 10, marginBottom: 10, }}
                            className={`regControlProductoPage__content ${ t.active ? 'active' : '' }`}
                            >
                            <Col xs={'2'} className="regVentaPage__listProduct">
                              <p style={{ color: '#333' }}>{t.folio}</p>
                            </Col>
                            <Col xs={'5'} className="regVentaPage__listProduct">
                              <p style={{ color: '#333' }}>{t.only_nombre}</p>
                            </Col>
                            <Col xs={'2'} className="regVentaPage__listProduct">
                              <p style={{ color: '#333' }}>${this.number_format(t.precio_venta,2)}</p>
                            </Col>
                            <Col xs={'3'} className="regVentaPage__listProduct">
                              <TimeAgo
                                style={{ color: (t.update == 1 ? '#333' : '#333'), }}
                                className="__listViewPending_time" date={t.fecha_cambio_costo} formatter={formatter}
                              />
                            </Col>
                          </Row>
                        ))
                      }
                    </div>

                  </>
                )
              }


            </Col>

          </Row>

          <Modal
            overlayClassName="Overlay__aplicaciones"
            isOpen={this.state.isOpenUpdateProduct}
            onRequestClose={() => { this.setState({isOpenUpdateProduct: false}) }}
            style={customStyles}
            contentLabel=""
            >
            <div className="modalBody__operador">
              <Row className="modalBody__corte"> 
                <Col>
                  <h4>Solicitud para unificar productos</h4>

                  <p>Ingresa el nombre del producto (opcional)</p>
                  <input type="text" placeholder="" value={arrayPrincipal.only_nombre} onChange={ (event) => {
                    arrayListProductos[indexLetter].listado[indexProducto].only_nombre = event.target.value;
                    this.setState({arrayListProductos})
                  } } />
                  <p>Ingresa el código del producto (opcional)</p>
                  <input type="text" placeholder="" value={arrayPrincipal.folio} onChange={ (event) => {
                    arrayListProductos[indexLetter].listado[indexProducto].folio = event.target.value;
                    this.setState({arrayListProductos})
                  } } />
                  <Select
                    onChange={(item) => {
                      console.log(item)
                      this.setState({
                        id_categoria_selected: item.id_categoria
                      })
                    }}
                    placeholder={arrayPrincipal.categoria}
                    options={this.state.arrayListCategorias}
                    styles={customStylesOption}
                  />

                  <button
                    style={{ padding: '5px 14px', cursor: 'pointer', textAlign: 'center', background: '#2980b9', color: '#fff', borderRadius: '4px', fontWeight: 600, width: '50%', margin: '0 auto', }}
                    onClick={ () => { this.setUpdateUnificaProductos(2) }} className="regVentaPage__title"
                  >Unificar productos</button>

                </Col>
              </Row>
            </div>
          </Modal>

        </div>
      </>
    );
  }

  onExpandLetter(e) {
    let { arrayListProductos } = this.state
    for(var a in arrayListProductos) {
      if(a != e) {
        arrayListProductos[a].show = false
      } else {
        if(arrayListProductos[a].show)
          arrayListProductos[a].show = false
        else
          arrayListProductos[a].show = true
      }

      if(a == (arrayListProductos.length - 1) ) {
        this.setState({
          arrayListProductos,
          indexLetter: e,
        })
      }
    }
  }

  onSelectProductoPrincipal(e) {
    let { arrayListProductos, indexLetter, indexProducto, } = this.state
    let t = arrayListProductos[indexLetter].listado[e]
    let val = (t.only_nombre.trim().split(' '))[0]
    let countLimit = 0
    let arr = []

    arr = arrayListProductos[indexLetter].listado.filter(function(producto, index) {
      if(countLimit <= 100) {
        if(typeof producto.only_nombre === 'undefined' || !producto.only_nombre) {
        } else {
          if(producto.only_nombre.toLowerCase().replace(/\s/g, '').indexOf(val.toLowerCase().replace(/\s/g, '')) !== -1) {
            if(index != e) {
              countLimit++
              return true
            }
          }
        }
      }
    });

    this.setState({
      valSearch: val,
      indexProducto: e,
      producto: t.only_nombre,
      // arraySelecteds: [],
      arrayListResults: arr,
    })

    // console.log('selectttt')
    // window.scrollTo(0, 0)
  }

  onSearchProducto(val) {
    let { arrayListProductos, indexLetter, indexProducto, } = this.state
    let arr = []

    this.setState({ valSearch: val })
    let countLimit = 0
    arr = arrayListProductos[indexLetter].listado.filter(function(producto, index) {
      if(countLimit <= 100) {
        if(typeof producto.only_nombre === 'undefined' || !producto.only_nombre) {
        } else {
          if(producto.only_nombre.toLowerCase().replace(/\s/g, '').indexOf(val.toLowerCase().replace(/\s/g, '')) !== -1) {
            if(index != indexProducto) {
              countLimit++
              return true
            }
          }
        }
      }
    });

    if(arr.length > 0)
      this.setState({ arrayListResults: arr, });
    else {
      this.setState({
        arrayListResults: [{
          categoria: "",
          compare_server: "",
          compare_venta: "",
          fecha_cambio_costo: "",
          folio: "",
          id_producto: "--",
          nombre: "No se encontraron resultados...",
          only_nombre: "No se encontraron resultados...",
          precio_venta: "",
          update: 0,
        }],
      });
    }
  }

  onSelectProductoSecundario(e) {
    let { arrayListResults } = this.state
    arrayListResults[e].active = arrayListResults[e].active ? false : true
    this.setState({ arrayListResults })
  }

  setUpdateUnificaProductos(opt) {

    if(opt === 1) {
      let { arrayListProductos, arrayListResults, indexLetter, indexProducto, } = this.state
      let arrayPrincipal = arrayListProductos[indexLetter].listado[indexProducto]
      let arrSecundarios = []

      for(var a in arrayListResults) {
        if(arrayListResults[a].active) {
          arrSecundarios.push(arrayListResults[a])
        }

        if(a == (arrayListResults.length - 1)) {
          if(arrSecundarios.length === 0) {
            alert('No haz seleccionado ningún producto a unir.')
            return false
          }
        }
      }

      this.setState({
        isOpenUpdateProduct: true,
      })
      
    } else {
      let { arrayListProductos, arrayListResults, indexLetter, indexProducto, id_categoria_selected, } = this.state
      let arrayPrincipal = arrayListProductos[indexLetter].listado[indexProducto]
      let arrSecundarios = []

      for(var a in arrayListResults) {
        if(arrayListResults[a].active) {
          arrSecundarios.push(arrayListResults[a])
        }

        if(a == (arrayListResults.length - 1)) {
          if(arrSecundarios.length === 0) {
            alert('No haz seleccionado ningún producto a unir.')
            return false
          }

          var opcion = window.confirm("¿Estás seguro que deseas unir estos productos?\nEsta acción no se puede deshacer.");
          if (opcion == true) {
            let data = {
              arrayPrincipal,
              arrSecundarios,
              id_categoria_selected,
            }

            fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=setUpdateUnificaProductos", this.headersPOST({ ...data, }))
            .then(response => response.json())
            .then((response) => {
              this.setState({
                id_categoria_selected: '',
                isOpenUpdateProduct: false,
              })
              this.getCostosByDate()
              alert('Producto unificado con éxito, cargando información...')
            })
          }
        }

      }

    }


  }

  getCostosByDate() {
    const { date, arrListVenta, } = this.state

    const data = {
      date,
      arrListVenta: [],
      alphabet: true,
    }

    //Solicitamos siempre información actualizada.
    fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=getRelationCostosByDate", this.headersPOST({ ...data, }))
    .then(response => response.json())
    .then((response) => {

      let { countTotal, countUpdate, arrayListProductos, indexLetter, arrayListCategorias, noDocEntradaAlmacen, arrayDespachadores, arrListVenta, numVentaGlobal } = response

      for(var a in arrayListProductos) {
        for(var b in arrayListProductos[a].listado) {
          const nombre = arrayListProductos[a].listado[b].only_nombre
          if(!nombre) {
            console.log(arrayListProductos[a].listado[b].id_producto)
          }
        }

        if(a == (arrayListProductos.length - 1)) {
          //Verificamos si hay que actualizar costos de productos ya vendiendo
          this.setState({
            arrayListResults: [],
            numVentaGlobal,
            countTotal,
            countUpdate,
            arrayListProductos,
            arrayListCategorias,
            noDocEntradaAlmacen,
            arrayDespachadores,
            arrListVenta,
          })

          if(this.state.indexLetter > -1) {
            arrayListProductos[indexLetter].show = true
            this.setState({
              arrayListProductos
            })
          }
        }
      }

    }).catch((error) => {
      // alert('Se requiere de una conexión a internet para esta área.')
    })
  }

  initsetState(param) {
    this.props.initsetState(param)
    return true
  }

  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

  getStyleModal(opt) {
    if(opt === 'isOpenListVentaByID') {
      return { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '50%',height: '50%',} };
    }

    return { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '80%',height: '80%',} };
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }

  uniqid() {
    var pr = '', en = false, result;this.seed = function (s, w) {s = parseInt(s, 10).toString(16);return w < s.length ? s.slice(s.length - w) : (w > s.length) ? new Array(1 + (w - s.length)).join('0') + s : s;};result = pr + this.seed(parseInt(new Date().getTime() / 1000, 10), 8) + this.seed(Math.floor(Math.random() * 0x75bcd15) + 1, 5);if (en) {result += (Math.random() * 10).toFixed(8).toString();} return result;
  }

};

export default withRouter(RegistrosControlProductosPage)